import { cookies } from '../_helpers'

export const magazineServices = {
    getMagazines,
}

function getMagazines() {
    const requestOptions = {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
            'X-CSRFToken': cookies.getCookie('csrftoken'),
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
    }

    return fetch('/api/magazines/', requestOptions)
        .then(res => res.json())
        .then(data => data)
}
